import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import femaleLoaderJson from '@/data/lottie-animations/femaleLoader.json'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingLottieAnimation', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		// TODO(L10N-2655): switch to an i18n key once web.json carries a lymphatic namespace.
		// Hardcoded EN: the funnel is EN-only and web.json is served from the CDN, not this repo.
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'Lymphatic Walking Plan<br/>Based on Your Age',
			size: 'small',
		}),

		LandingLottieAnimation: (): LandingComponentsConfig['LandingLottieAnimation'] => ({
			animationData: femaleLoaderJson,
			loop: false,
			customStyles: {
				height: '50vh',
				marginTop: 'var(--size-18)',
				marginBottom: 'var(--size-18)',
			},
		}),

		// Label and note intentionally omitted — the component's defaults are already the
		// Figma copy (landing_male.loader.label / .note).
		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
